import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'

const AcceptInviteDialog: FC<{
  showConfirmationDialog: boolean
  groups: any
  isFirstStepCompleted?: boolean
}> = ({showConfirmationDialog, groups, isFirstStepCompleted}) => {
  const [isConfirmed, setIsConfirmed] = useState(isFirstStepCompleted)

  const handleConfirmData = () => {
    setIsConfirmed(true)
  }

  const handleLinkButton = (path: string) => {
    window.location.replace(path)
  }

  const isCompanyAdmin = groups.some((group: any) => group === 'Company Admins')
  const isSupervisorOrHS = groups.some((group: any) =>
    ['Supervisor', 'H&S Specialist'].includes(group)
  )

  return (
    <>
      {showConfirmationDialog && (
        <Modal show={showConfirmationDialog} tabIndex={0} centered>
          <Modal.Body>
            <div className='py-5 d-flex flex-column gap-6'>
              {isFirstStepCompleted ? (
                <video
                  className='exclamation align-self-center'
                  src='/media/exclamation.mp4'
                  autoPlay
                  loop
                  muted
                  playsInline
                  poster='/media/exclamation.gif'
                />
              ) : (
                <img
                  className='congratulations align-self-center'
                  src='/media/congratulations.gif'
                  alt='Congratulations'
                />
              )}
              <div className='d-flex gap-1 flex-column'>
                <div className='align-self-center congratulation-text'>
                  {isFirstStepCompleted ? 'Access Restricted' : 'Congratulations !'}
                </div>
                <div>
                  <div className='congratulation-sub-text align-self-center text-center'>
                    {isFirstStepCompleted
                      ? 'This portal is only for admin users.'
                      : 'Your User Created Successfully.'}
                  </div>
                  <div className='congratulation-sub-text align-self-center text-center'>
                    {isFirstStepCompleted &&
                      'Kindly log in through the Web App or Mobile App to proceed.'}
                  </div>
                </div>
              </div>
              {isConfirmed ? (
                <div className='btn-align'>
                  {isCompanyAdmin && (
                    <button
                      type='submit'
                      className='btn btn-primary btn-pill accept-invite-redirect-btn align-self-center link-btn'
                      onClick={() => handleLinkButton(`${process.env.REACT_APP_URL}`)}
                    >
                      Continue on Admin Panel
                      <img
                        className='ms-3'
                        src='/media/icons/duotune/general/Arrow - Right.svg'
                        alt='->'
                      />
                    </button>
                  )}
                  {isSupervisorOrHS && (
                    <>
                      <button
                        type='submit'
                        className='btn btn-pill accept-invite-redirect-btn mobile-app-link-btn align-self-center link-btn'
                        onClick={() => handleLinkButton(`${process.env.REACT_APP_API_FLUTTER_URL}`)}
                      >
                        Login to Web App
                        <img
                          className='ms-3'
                          src='/media/icons/duotune/general/blue-arrow.svg'
                          alt='->'
                        />
                      </button>
                      <button
                        type='submit'
                        className='btn btn-pill accept-invite-redirect-btn mobile-app-link-btn align-self-center link-btn'
                        onClick={() => handleLinkButton(`${process.env.REACT_APP_MOBILE_URL}`)}
                        style={{marginTop: '0.3rem'}}
                      >
                        Continue on Mobile App
                        <img
                          className='ms-3'
                          src='/media/icons/duotune/general/blue-arrow.svg'
                          alt='->'
                        />
                      </button>
                    </>
                  )}
                </div>
              ) : (
                <button
                  type='submit'
                  className='btn btn-primary btn-pill dialog-done-btn submit-btn align-self-center'
                  onClick={handleConfirmData}
                >
                  Done
                  <img
                    className='ms-3'
                    src='/media/icons/duotune/general/Arrow - Right.svg'
                    alt='->'
                  />
                </button>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export {AcceptInviteDialog}
